import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomLoader from "../../components/CustomeLoader";
import Accordion from "react-bootstrap/Accordion";
// import socialicon1 from "../../ulits/images/social-icon1.svg";
import socialicon2 from "../../ulits/images/social-icon2.svg";
import socialicon3 from "../../ulits/images/social-icon3.svg";
import socialicon4 from "../../ulits/images/social-icon4.svg";
import socialicon5 from "../../ulits/images/social-icon5.svg";
import socialicon6 from "../../ulits/images/social-icon6.svg";
import socialicon7 from "../../ulits/images/social-icon7.svg";
import socialicon8 from "../../ulits/images/social-icon8.svg";
import socialicon9 from "../../ulits/images/social-icon9.svg";
import socialicon10 from "../../ulits/images/social-icon10.svg";
import socialicon11 from "../../ulits/images/social-icon11.svg";
import socialicon12 from "../../ulits/images/social-icon12.svg";
// import carimg2 from "../../ulits/images/car_img2.png";
import milionicon from "../../ulits/images/milion_icon.svg";
import petrolicon from "../../ulits/images/petrol_icon.svg";
import manualicon from "../../ulits/images/manual_icon.svg";
import bolteg from "../../ulits/images/bolteg.png";
import { useSelector, useDispatch } from "react-redux";
import { configs } from "../../config";
import { homeAction } from "../../_actions";
import { status } from "../../_constants/commonLhd";
import ReactSlider from "react-slider";
import filterbackarrow from "../../ulits/images/filter_back_arrow.svg";
import filtericon from "../../ulits/images/filter_icon.svg";
import { Helmet } from "react-helmet";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import location from "../../ulits/images/location-icon.svg";
dayjs.extend(customParseFormat);

function CarListing() {
  const [loader, setLoading] = useState(true);
  const [list, setList] = useState(false);
  const [handDrive, setHandDrive] = useState();
  const [condition, setCondition] = useState();
  const [sorting, setSortings] = useState();
  const [drive, setDrive] = useState([]);
  const [transmission, setTransmission] = useState([]);
  const [fuelType, setFuelType] = useState([]);
  const [name, setName] = useState([]);
  const [cars, setCars] = useState([]);
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || [];
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState([0, 500000]);
  const [value, setValue] = useState([2000, new Date().getFullYear()]);
  const [active, setActive] = useState("button1");
  const [valued, setValued] = useState([0, 1000000]);
  const [seo, setSeo] = useState({});
  const [makes, setMakes] = useState([]);
  const makesData = useSelector((state) => state.home.make_data);
  const makeStatus = useSelector((state) => state.home.make_status);
  const currentYear = new Date().getFullYear();

  const ToggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const dispatch = useDispatch();
  const homeData = useSelector((state) => state.home);
  const seoData = useSelector((state) => state.config);

  useEffect(() => {
    if (seoData && seoData.seo_status === status.SUCCESS) {
      setSeo(seoData.seo_data);
    }
  }, [seoData]);

  useEffect(() => {
    dispatch(homeAction.getCarsByTenantId());
  }, []);

  useEffect(() => {
    if (makeStatus === status.SUCCESS && makesData?.length > 0) {
      const activeMakes = makesData.filter((make) => make.status === true);
      setMakes(activeMakes);
    }
  }, [makeStatus, makesData]);

  useEffect(() => {
    dispatch(homeAction.getMakesByTenantId());
  }, []);

  const toCarArray = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.cars)) return data.cars;
    return [];
  };

  useEffect(() => {
    if (homeData && homeData.car_details_status === status.SUCCESS) {
      const list = toCarArray(homeData?.car_details_data);
      const activeCars = list.filter((car) => car?.status === true);
      setCars(activeCars);
    }
  }, [homeData?.car_details_data, homeData?.car_details_status]);
  useEffect(() => {
    let filteredCars = (homeData.car_data || []).filter(
      (car) => car.status === true,
    );

    if (handDrive === true) {
      filteredCars = filteredCars.filter((car) => car.leftHendDrive);
    } else if (handDrive === false) {
      filteredCars = filteredCars.filter((car) => car.rightHendDrive);
    } else if (condition === "Used") {
      filteredCars = filteredCars.filter((car) => car.condition === "Used");
    } else if (condition === "Un used") {
      filteredCars = filteredCars.filter((car) => car.condition === "Un used");
    }
    if (handDrive === true && condition === "Used") {
      filteredCars = filteredCars.filter(
        (car) => car.leftHendDrive && car.condition === "Used",
      );
    } else if (handDrive === true && condition === "Un used") {
      filteredCars = filteredCars.filter(
        (car) => car.leftHendDrive && car.condition === "Un used",
      );
    }
    if (handDrive === false && condition === "Used") {
      filteredCars = filteredCars.filter(
        (car) => car.rightHendDrive && car.condition === "Used",
      );
    } else if (handDrive === false && condition === "Un used") {
      filteredCars = filteredCars.filter(
        (car) => car.rightHendDrive && car.condition === "Un used",
      );
    }
    if (drive.length > 0) {
      filteredCars = filteredCars.filter((car) =>
        drive.includes(car.drive.trim()),
      );
    }
    if (name.length > 0) {
      filteredCars = filteredCars.filter((car) =>
        name.includes(car.name.trim()),
      );
    }

    if (transmission.length > 0) {
      filteredCars = filteredCars.filter((car) =>
        transmission.includes(car.transmission.trim()),
      );
    }

    if (fuelType.length > 0) {
      filteredCars = filteredCars.filter((car) =>
        fuelType.includes(car.fuelType.trim()),
      );
    }

    filteredCars = filteredCars.filter(
      (car) => car.mileage >= values[0] && car.mileage <= values[1],
    );

    filteredCars = filteredCars.filter(
      (car) =>
        car.menuFacturingYear >= value[0] && car.menuFacturingYear <= value[1],
    );

    filteredCars = filteredCars.filter(
      (car) => car.price >= valued[0] && car.price <= valued[1],
    );

    if (sorting === "priceLowToHigh") {
      filteredCars.sort((a, b) => a.price - b.price);
    } else if (sorting === "priceHighToLow") {
      filteredCars.sort((a, b) => b.price - a.price);
    } else if (sorting === "oldest") {
      filteredCars.sort((a, b) => b.menuFacturingYear - a.menuFacturingYear);
    } else if (sorting === "newest") {
      filteredCars.sort((a, b) => a.menuFacturingYear - b.menuFacturingYear);
    } else if (sorting === "mileage") {
      filteredCars.sort((a, b) => b.mileage - a.mileage);
    } else if (sorting === "mostRecent") {
      filteredCars.sort((a, b) => {
        const dateA = dayjs(a.createdAt, "DD/MM/YYYY, hh:mm:ss a");
        const dateB = dayjs(b.createdAt, "DD/MM/YYYY, hh:mm:ss a");
        return dateB.valueOf() - dateA.valueOf();
      });
    }
    // else if (sorting === "distanceLowToHigh") {
    //   filteredCars.sort((a, b) => b.distance - a.distance);
    // }
    setCars(filteredCars);
  }, [
    handDrive,
    condition,
    drive,
    name,
    transmission,
    values,
    value,
    valued,
    fuelType,
    sorting,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const toggleDrive = (value) => {
    setDrive((prevDrive) =>
      prevDrive.includes(value)
        ? prevDrive.filter((item) => item !== value)
        : [...prevDrive, value],
    );
  };


  const toggleMake = (value) => {
    setName((prevDrive) =>
      prevDrive.includes(value)
        ? prevDrive.filter((item) => item !== value)
        : [...prevDrive, value],
    );
  };

  const toggleTransmission = (value) => {
    setTransmission((prevDrive) =>
      prevDrive.includes(value)
        ? prevDrive.filter((item) => item !== value)
        : [...prevDrive, value],
    );
  };

  const toggleFuelType = (value) => {
    setFuelType((prevDrive) =>
      prevDrive.includes(value)
        ? prevDrive.filter((item) => item !== value)
        : [...prevDrive, value],
    );
  };

  const handleSelection = (e) => {
    setHandDrive(e.target.value);
  };

  const getUniqueSlug = (slug) => {
    let count = 0;
    cars.forEach((car) => {
      if (car.slug === slug) {
        count++;
      }
    });

    if (count > 1) {
      let newSlug = `${slug}-${count - 1}`;
      return newSlug;
    }
    return slug;
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={seo && seo.Car_Listing_Meta_Description}
        />
        <meta name="keywords" content={seo && seo.Car_Listing_Meta_Keywords} />
      </Helmet>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          <div className="car-listing-section">
            <div className="container">
              <div className="modern-filter-listing">
                <div
                  className={`car-listing-left ${isOpen == true ? "open" : ""}`}
                >
                  <div className="filter-header">
                    <div
                      className="filter-close"
                      onClick={() => setIsOpen(false)}
                    >
                      <img src={filterbackarrow} alt="Close Menu" />
                    </div>
                  </div>
                  <Accordion defaultActiveKey={["0"]} alwaysOpen>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon12} alt="location-icon" />
                          SORT BY
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="options first">
                          {/* <label>
                            <input
                              type="radio"
                              class="form-check-label"
                              for="flexRadioDefault1"
                              value="used"
                              checked={condition === "used"}
                              onClick={() =>
                                setCondition((prevCondition) =>
                                  prevCondition === "used" ? "" : "used"
                                )
                              }
                            />
                            <span>RELEVANCE</span>
                          </label> */}
                          {/* <label>
                            <input
                              type="radio"
                              value="mileage"
                              checked={sorting === "mileage"}
                              onChange={() => setSortings("mileage")}
                            />
                            <span>MILEAGE</span>
                          </label> */}
                        </div>
                        <div className="options first">
                          <label
                            className={
                              sorting === "priceLowToHigh" ? "checked" : ""
                            }
                          >
                            <input
                              type="radio"
                              value="Un used"
                              checked={sorting === "priceLowToHigh"}
                              onClick={() =>
                                setSortings((prevCondition) =>
                                  prevCondition === "priceLowToHigh"
                                    ? ""
                                    : "priceLowToHigh",
                                )
                              }
                            />
                            <span>PRICE (LOW TO HIGH)</span>
                          </label>
                          <label
                            className={sorting === "newest" ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              value="Un used"
                              checked={sorting === "newest"}
                              onClick={() =>
                                setSortings((prevCondition) =>
                                  prevCondition === "newest" ? "" : "newest",
                                )
                              }
                            />
                            <span>AGE (NEWEST)</span>
                          </label>
                        </div>
                        <div className="options first">
                          <label
                            className={
                              sorting === "priceHighToLow" ? "checked" : ""
                            }
                          >
                            <input
                              type="radio"
                              value="priceHighToLow"
                              checked={sorting === "priceHighToLow"}
                              onClick={() =>
                                setSortings((prevCondition) =>
                                  prevCondition === "priceHighToLow"
                                    ? ""
                                    : "priceHighToLow",
                                )
                              }
                            />
                            <span>PRICE (HIGH TO LOW)</span>
                          </label>
                          <label
                            className={sorting === "oldest" ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              value="Un used"
                              checked={sorting === "oldest"}
                              onClick={() =>
                                setSortings((prevCondition) =>
                                  prevCondition === "oldest" ? "" : "oldest",
                                )
                              }
                            />
                            <span>AGE (LOWEST)</span>
                          </label>
                        </div>
                        <div className="options first">
                          {/* <label>
                            <input
                              type="radio"
                              value="distanceLowToHigh"
                              checked={sorting === "distanceLowToHigh"}
                              onChange={() => setSortings("distanceLowToHigh")}
                            />
                            <span>DISTANCE</span>
                          </label> */}
                          <label
                            className={sorting === "mileage" ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              value="mileage"
                              checked={sorting === "mileage"}
                              onClick={() =>
                                setSortings((prevCondition) =>
                                  prevCondition === "mileage" ? "" : "mileage",
                                )
                              }
                            />
                            <span>MILEAGE</span>
                          </label>
                          <label
                            className={
                              sorting === "mostRecent" ? "checked" : ""
                            }
                          >
                            <input
                              type="radio"
                              value="mostRecent"
                              checked={sorting === "mostRecent"}
                              onClick={() =>
                                setSortings((prevCondition) =>
                                  prevCondition === "mostRecent"
                                    ? ""
                                    : "mostRecent",
                                )
                              }
                            />
                            <span>MOST RECENT</span>
                          </label>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon2} alt="location-icon" />
                          CONDITION
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="options">
                          <label
                            className={condition === "Used" ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              class="form-check-label"
                              for="flexRadioDefault1"
                              value="Used"
                              checked={condition === "Used"}
                              onClick={() =>
                                setCondition((prevCondition) =>
                                  prevCondition === "Used" ? "" : "Used",
                                )
                              }
                            />
                            <span>USED</span>
                          </label>
                          <label
                            className={condition === "Un used" ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              value="Un used"
                              checked={condition === "Un used"}
                              onClick={() =>
                                setCondition((prevCondition) =>
                                  prevCondition === "Un used" ? "" : "Un used",
                                )
                              }
                            />
                            <span>UNUSED</span>
                          </label>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon3} alt="location-icon" />
                          HAND DRIVE
                        </div>
                      </Accordion.Header>
                      {/* <Accordion.Body> */}
                      {/* <div className="toggle-wrapper"> */}
                      {/* <span className="toggle-label">
                            {" "}
                            {handDrive === true
                              ? "Left hand drive"
                              : "Left hand drive"}
                          </span> */}
                      {/* <div
                            className={`switch ${handDrive ? 'on' : 'off'}`}
                            onClick={() => setHandDrive(prev => !prev)}
                          >
                            <div className="switch-toggle" />
                          </div> */}
                      {/* <label className="switch">
                            <input
                              type="checkbox"
                              checked={handDrive === true}
                              onChange={() => {
                                setHandDrive((prev) =>
                                  prev === true ? false : true
                                );
                              }}
                            />
                            <span className="slider"></span>
                          </label> */}
                      {/* </div> */}
                      {/* </Accordion.Body> */}

                      <Accordion.Body>
                        <div className="options">
                          <label
                            className={handDrive === false ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              value="true"
                              checked={handDrive == false}
                              onClick={() =>
                                setHandDrive((prev) =>
                                  prev === false ? null : false,
                                )
                              }
                            />
                            <span>RIGHT</span>
                          </label>
                          <label
                            className={handDrive === true ? "checked" : ""}
                          >
                            <input
                              type="radio"
                              value="false"
                              checked={handDrive == true}
                              onClick={() =>
                                setHandDrive((prev) =>
                                  prev === true ? null : true,
                                )
                              }
                            />
                            <span>LEFT</span>
                          </label>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon4} alt="location-icon" />
                          MAKE
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {/* <div className="sort-list">
                          <div className="sort-by">
                            <label
                              className={
                                name.includes("Acura") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="Acura"
                                checked={name.includes("Acura")}
                                onChange={() => toggleMake("Acura")}
                              />
                              <span>ACURA</span>
                            </label>
                          </div>
                          <div className="sort-by">
                            <label
                              className={
                                name.includes("Acuro") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="Acuro"
                                checked={name.includes("Acuro")}
                                onChange={() => toggleMake("Acuro")}
                              />
                              <span>ACURO</span>
                            </label>
                          </div>
                        </div> */}
                        <div className="sort-list">
                          <div className="sort-by">
                            {makes.map((make) => (
                              <label
                                key={make._id}
                                className={
                                  name.includes(make.makeName) ? "checked" : ""
                                }
                              >
                                <input
                                  type="checkbox"
                                  value={make.makeName}
                                  checked={name.includes(make.makeName)}
                                  onChange={() => toggleMake(make.makeName)}
                                />
                                <span>{make.makeName.toUpperCase()}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon5} alt="location-icon" />
                          MILEAGE
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="slider-labels">
                          <div className="slider-label">MIN</div>
                          <div className="slider-label">MAX</div>
                        </div>
                        <ReactSlider
                          className="range-slider"
                          thumbClassName="thumb"
                          trackClassName="track"
                          defaultValue={values}
                          min={0}
                          max={500000}
                          step={100}
                          value={values}
                          onChange={(val) => setValues(val)}
                          pearling
                        />
                        <div className="slider-values">
                          <span>{values[0]}</span>
                          <span>{values[1]}</span>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    {/* <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon6} alt="location-icon" />
                          YEAR  ({new Date().getFullYear()})
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="slider-labels">
                          <div className="slider-label">MIN</div>
                          <div className="slider-label">MAX</div>
                        </div>
                        <ReactSlider
                          className="range-slider"
                          thumbClassName="thumb"
                          trackClassName="track"
                          min={2000}
                          max={2025}
                          step={1}
                          value={value}
                          onChange={(val) => setValue(val)}
                          pearling
                        />
                        <div className="slider-values">
                          <span>{value[0]}</span>
                          <span>{value[1]}</span>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item> */}
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon6} alt="location-icon" />
                          YEAR
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="slider-labels">
                          <div className="slider-label">MIN</div>
                          <div className="slider-label">MAX</div>
                        </div>
                        <ReactSlider
                          className="range-slider"
                          thumbClassName="thumb"
                          trackClassName="track"
                          min={2010}
                          max={currentYear}
                          step={1}
                          value={value}
                          onChange={(val) => setValue(val)}
                          pearling
                        />
                        <div className="slider-values">
                          <span>{value[0]}</span>
                          <span>{value[1]}</span>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon7} alt="location-icon" />
                          PRICE
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="slider-labels">
                          <div className="slider-label">MIN</div>
                          <div className="slider-label">MAX</div>
                        </div>
                        <ReactSlider
                          className="range-slider"
                          thumbClassName="thumb"
                          trackClassName="track"
                          defaultValue={valued}
                          min={0}
                          max={600000}
                          step={5000}
                          value={valued}
                          onChange={(val) => setValued(val)}
                          pearling
                        />
                        <div className="slider-values">
                          <span>{valued[0]}</span>
                          <span>{valued[1]}</span>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="8">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon8} alt="location-icon" />
                          TRANSMISSION
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="sort-list">
                          <div className="sort-by">
                            <label
                              className={
                                transmission.includes("AUTOMATIC")
                                  ? "checked"
                                  : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="AUTOMATIC"
                                checked={transmission.includes("AUTOMATIC")}
                                onChange={() => toggleTransmission("AUTOMATIC")}
                              />
                              <span>AUTO</span>
                            </label>
                            <label
                              className={
                                transmission.includes("MANUAL") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="MANUAL"
                                checked={transmission.includes("MANUAL")}
                                onChange={() => toggleTransmission("MANUAL")}
                              />
                              <span>MANUAL</span>
                            </label>
                            {/* <label>
                              <input
                                type="checkbox"
                                value="MANUAL"
                                checked={transmission.includes("MANUAL")}
                                onChange={() => toggleTransmission("MANUAL")}
                              />
                              <span>MANUAL</span>
                            </label> */}
                          </div>
                          <div className="sort-by" style={{
                            gridTemplateColumns: "repeat(1, 1fr)"
                          }}>
                            {/* <label>
                              <input
                                type="checkbox"
                                value="AUTOMATIC TIPTRONIC"
                                checked={transmission.includes(
                                  "AUTOMATIC TIPTRONIC"
                                )}
                                onChange={() =>
                                  toggleTransmission("AUTOMATIC TIPTRONIC")
                                }
                              />
                              <span>AUTOMATIC TIPTRONIC</span>
                            </label> */}
                            <label
                              className={
                                transmission.includes("SEMI AUTOMATIC")
                                  ? "checked"
                                  : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="SEMI AUTOMATIC"
                                checked={transmission.includes(
                                  "SEMI AUTOMATIC",
                                )}
                                onChange={() =>
                                  toggleTransmission("SEMI AUTOMATIC")
                                }
                              />
                              <span>SEMI AUTOMATIC</span>
                            </label>
                            {/* <label>
                              <input
                                type="checkbox"
                                value="MANUAL"
                                checked={transmission.includes("MANUAL")}
                                onChange={() => toggleTransmission("MANUAL")}
                              />
                              <span>MANUAL</span>
                            </label> */}
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="9">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={socialicon9} alt="location-icon" />
                          DRIVE
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="sort-list">
                          <div className="sort-by">
                            <label
                              className={drive.includes("4WD") ? "checked" : ""}
                            >
                              <input
                                type="checkbox"
                                value="4WD"
                                checked={drive.includes("4WD")}
                                onChange={() => toggleDrive("4WD")}
                              />
                              <span>4WD</span>
                            </label>
                            <label
                              className={drive.includes("FWD") ? "checked" : ""}
                            >
                              <input
                                type="checkbox"
                                value="FWD"
                                checked={drive.includes("FWD")}
                                onChange={() => toggleDrive("FWD")}
                              />
                              <span>FWD</span>
                            </label>
                          </div>
                          <div className="sort-by">
                            <label
                              className={drive.includes("AWD") ? "checked" : ""}
                            >
                              <input
                                type="checkbox"
                                value="AWD"
                                checked={drive.includes("AWD")}
                                onChange={() => toggleDrive("AWD")}
                              />
                              <span>AWD</span>
                            </label>
                            <label
                              className={drive.includes("RWD") ? "checked" : ""}
                            >
                              <input
                                type="checkbox"
                                value="RWD"
                                checked={drive.includes("RWD")}
                                onChange={() => toggleDrive("RWD")}
                              />
                              <span>RWD</span>
                            </label>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        <div className="car-listing-icon">
                          <img src={petrolicon} alt="location-icon" />
                          FUEL TYPE
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="sort-list">
                          <div className="sort-by">
                            <label
                              className={
                                fuelType.includes("Petrol") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="PETROL"
                                checked={fuelType.includes("Petrol")}
                                onChange={() => toggleFuelType("Petrol")}
                              />
                              <span>PETROL</span>
                            </label>
                            <label
                              className={
                                fuelType.includes("Diesel") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="DIESEL"
                                checked={fuelType.includes("Diesel")}
                                onChange={() => toggleFuelType("Diesel")}
                              />
                              <span>DIESEL</span>
                            </label>
                          </div>
                          <div className="sort-by">
                            <label
                              className={
                                fuelType.includes("Electric") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="ELECTRIC"
                                checked={fuelType.includes("Electric")}
                                onChange={() => toggleFuelType("Electric")}
                              />
                              <span>ELECTRIC</span>
                            </label>
                            <label
                              className={
                                fuelType.includes("CNG") ? "checked" : ""
                              }
                            >
                              <input
                                type="checkbox"
                                value="CNG"
                                checked={fuelType.includes("CNG")}
                                onChange={() => toggleFuelType("CNG")}
                              />
                              <span>CNG</span>
                            </label>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div className="car-listing-right">
                  <div className="car-listing-right-top">
                    <div className="car-listing-right-top-left">
                      <div className="car-listing-right-top-left-text">
                        <h1>
                          {cars.length} CAR{" "}
                          {cars.length !== 1 ? "MODELS" : "MODEL"} AVAILABLE
                        </h1>
                        <div className="filter-sidebar filter-btn d-block d-md-none">
                          <button
                            className={`filter-menu ${isOpen == true ? "open" : ""
                              }`}
                            onClick={() => setIsOpen(!isOpen)}
                          >
                            <img src={filtericon} alt="location-icon" />
                            FILTER
                            <span>{cars.length}</span>
                          </button>
                        </div>
                        <div className="car-listing-right-top-left-icon d-none d-md-flex">
                          <div
                            className={list ? "icon inactive" : "icon active"}
                            onClick={() => setList(false)}
                          >
                            <img src={socialicon10} alt="location-icon" />
                          </div>
                          <div
                            className={list ? "icon active" : "icon inactive"}
                            onClick={() => setList(true)}
                          >
                            <img src={socialicon11} alt="location-icon" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={`${list ? "list-row" : "row"}`}>
                      {cars &&
                        cars.map((cars, index) => {
                          const uniqueSlug = getUniqueSlug(cars.slug, cars);
                          return (
                            <div
                              className={`${list
                                  ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 list-vertical"
                                  : "col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12 list-vertical"
                                }`}
                              key={cars._id}
                            >
                              <a>
                                <div className="blog-listing-box">
                                  <div className="blog-listing-img">
                                    <img
                                      src={`${configs.localApiUrl}${cars.image[0]}`}
                                      alt=""
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        navigate(`/car-details/${uniqueSlug}`, {
                                          state: cars,
                                        })
                                      }
                                    />
                                  </div>
                                  <div className="blog-listing-text">
                                    <h1>
                                      {cars && cars.details.toUpperCase()}
                                    </h1>
                                    <ul>
                                      <li>
                                        <Link to="#">
                                          <img
                                            src={milionicon}
                                            alt="arrow-icon"
                                          />
                                          {Number(cars.mileage).toLocaleString(
                                            "en-IN",
                                          )}{" "}
                                          MILES
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="#">
                                          <img
                                            src={petrolicon}
                                            alt="arrow-icon"
                                          />
                                          {cars && cars.fuelType.toUpperCase()}
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="#">
                                          <img
                                            src={manualicon}
                                            alt="arrow-icon"
                                          />
                                          {cars &&
                                            cars.transmission.toUpperCase()}
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="#">
                                          <img src={bolteg} alt="arrow-icon" />
                                          {cars.engine}
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="#">
                                          <img
                                            src={location}
                                            alt="arrow-icon"
                                          />
                                          {cars &&
                                            cars.location &&
                                            cars.location.toUpperCase()}
                                        </Link>
                                      </li>
                                    </ul>
                                    <div className="grop-btn">
                                      <button
                                        className={
                                          active === "button1" ? "active" : ""
                                        }
                                        onClick={() => setActive("button1")}
                                      >
                                        £
                                        {Number(cars.price).toLocaleString(
                                          "en-IN",
                                        )}
                                        {/* £{cars.price} */}
                                      </button>
                                      <button
                                        onClick={() =>
                                          navigate(
                                            `/car-details/${uniqueSlug}`,
                                            {
                                              state: cars,
                                            },
                                          )
                                        }
                                      >
                                        DISCOVER
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="stm-accordion-single-unit">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              {faqList.length > 0 &&
                faqList.map((item, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>{item.ans}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default CarListing;
